/**
 * The TAX slice of the Admin surface: tax groups (design U5, migration 30).
 *
 * Named `routes.tax.tsx` for the reason `routes.infra.tsx` and `routes.catalogue.tsx`
 * record — one route array per work stream, meeting only in `src/routes.extra.ts`,
 * so streams never race for one filename.
 *
 * Mounts INSIDE `RequireCountry` + `AppShell` under `/countries/:cc/admin/…`; the
 * screen uses inline alerts, not the inquiries toast, so no provider layout is
 * needed (the infra slice's precedent).
 */

import type { RouteObject } from 'react-router-dom';
import { TaxGroupsPage } from './TaxGroupsPage';

export const adminTaxRoutes: RouteObject[] = [
  { path: 'admin/tax-groups', element: <TaxGroupsPage /> },
];
